
import Home from "./pages/Home/Home"

import GlowingDotsGrid from "./components/GlowingDotsGrid/GlowingDotsGrid"
const routes = [
  {
    path: "/",
    element: <Home/>,
  },
  {
    path: "/glowing-dots-grid",
    element: <GlowingDotsGrid/>,
  }
  
];
export default routes;